import { connect } from 'react-redux'
import mapSelectorsToProps from 'aria-viewer/core/selectors/mapSelectorsToProps'
import { openCTAPrompt, closeCTAPrompt } from 'aria-viewer/ctaPrompt/ctaPromptActions'
import lifecycle from 'recompose/lifecycle'
import compose from 'recompose/compose'
import CTAPrompt from '../components/CTAPrompt'
import { AccessibilityController } from '../../legacy'
import { WithAnimation } from 'aria-viewer/common'
import ModalContentTypes from 'aria-viewer/modal/constants/ModalContentTypes'

const mapDispatchToProps = (dispatch, ownProps) => ({
    openCTAPrompt: _ => {
        dispatch(
            openCTAPrompt({
                isModal: false,
                promptType: ownProps.promptType,
            })
        )
    },

    closeCTAPrompt: _ => {
        dispatch(closeCTAPrompt({ isModal: true }))
    },
})

const handleButtonClose = (e, ownProps, actions) => {
    // prevent default behaviors for mouse event
    e && e.stopPropagation && e.stopPropagation()
    e && e.nativeEvent && e.nativeEvent.stopImmediatePropagation()
    e && e.preventDefault && e.preventDefault()

    // if we're not actually in a modal, we can
    // override/augment behavior via onClose prop
    if (ownProps.onClose) {
        ownProps.onClose()
    }

    // if we are in a modal, close
    // (otherwise, unmounting takes care of legacy non-modals
    //  tracking if close has occurred)
    if (ownProps.isModal) {
        actions.closeCTAPrompt()
    }
}

const mergeProps = (state, actions, ownProps) => ({
    ...state,
    ...actions,
    ...ownProps,

    onClickCloseButton: e => {
        handleButtonClose(e, ownProps, actions)
    },

    onKeyPress: e => {
        if (e.key == 'Enter') {
            handleButtonClose(e, ownProps, actions)
        }
    },
})

export default compose(
    connect(
        mapSelectorsToProps(['isDeviceMobile', 'ctaPromptType', 'modalStack']),
        mapDispatchToProps,
        mergeProps
    ),
    lifecycle({
        componentDidMount: function() {
            // needed to trigger "isCTAPromptOpen" so that registrationWrapper
            // can have a transparent background when the prompt wasn't
            // launched directly as a modal
            if (!this.props.isModal) {
                this.props.openCTAPrompt()
            }
            AccessibilityController.modalShown('#act_now_modal')
        },

        componentWillUnmount: function() {
            // needed to trigger "isCTAPromptOpen" so that registrationWrapper
            // can have a transparent background when the prompt wasn't
            // launched directly as a modal
            if (!this.props.isModal) {
                this.props.closeCTAPrompt()
            }
            AccessibilityController.modalDismissed('#act_now_modal')
        },
    }),
    WithAnimation({
        style: {
            zIndex: 10000,
        },

        show: ({ modalStack, isModal }) =>
            isModal === false ||
            modalStack
                .filter(modal => !modal.content.hasIndependentContainer)
                .some(modal => modal.content.contentType == ModalContentTypes.CTA_PROMPT),
        start: {
            opacity: 0,
        },

        enter: {
            opacity: [1],
            timing: { duration: 200 },
        },

        update: {
            opacity: [1],
            timing: { duration: 200 },
        },

        leave: {
            opacity: [0],
            timing: { duration: 200 },
        },
    })
)(CTAPrompt)
